import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AssessmentTypeService } from '../AssessmentTypeService';

export const useCreateAssessmentType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => AssessmentTypeService.createAssessmentType(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assessment-types'] });
    },
  });
};

export const useUpdateAssessmentType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ code, data }) =>
      AssessmentTypeService.updateAssessmentType(code, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assessment-types'] });
    },
  });
};

export const useDeleteAssessmentType = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (code) => AssessmentTypeService.deleteAssessmentType(code),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['assessment-types'] });
    },
  });
};
